import PretrainedApp from '@strongio/pretrained-dashboard/views/app';
import '../tailwind.css';

export default PretrainedApp;
